var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flexs column relative"
  }, [_c('common-title', {
    attrs: {
      "title": "丰富的广告场景形态"
    }
  }, [_c('tabs', {
    staticClass: "z-6",
    attrs: {
      "tabs": _vm.sceneList,
      "default-active": 0
    },
    on: {
      "tab-change": _vm.onTabChange
    }
  }, [_c('transition', {
    attrs: {
      "name": "tab-fade",
      "mode": "out-in"
    },
    on: {
      "enter": _vm.onEnter,
      "leave": _vm.onLeave
    }
  }, [_c('div', {
    key: _vm.activeIndex,
    staticClass: "flexs jc-sb margin-t-30",
    class: _vm.animationClass
  }, [_c('div', {
    staticClass: "flexs column text-l max-w-500"
  }, [_c('div', {
    staticClass: "flexs column margin-b-70"
  }, [_c('span', {
    staticClass: "fs-30 margin-b-10 f-700"
  }, [_vm._v(_vm._s(_vm.sceneList[_vm.activeIndex].name))]), _c('span', {
    staticClass: "fs-18 c-6"
  }, [_vm._v(_vm._s(_vm.sceneList[_vm.activeIndex].content))])]), _vm._l(_vm.sceneList[_vm.activeIndex].tips, function (tipItem, tipIndex) {
    return _c('div', {
      key: tipIndex,
      staticClass: "fs-18 c-303650"
    }, [_c('div', {
      staticClass: "flexs al-c"
    }, [_c('i', {
      staticClass: "el-icon-check",
      staticStyle: {
        "color": "#2e6afa"
      }
    }), _c('span', {
      staticClass: "margin-l-10"
    }, [_vm._v(_vm._s(tipItem))])])]);
  })], 2), _c('div', {
    staticClass: "flexs jc-sb f1 margin-l-220"
  }, _vm._l(_vm.sceneList[_vm.activeIndex].imgs, function (item, index) {
    return _c('img', {
      key: index,
      staticStyle: {
        "width": "240px",
        "height": "530px"
      },
      attrs: {
        "src": _vm.getImagePath(1, item)
      }
    });
  }), 0)])])], 1)], 1), _c('transition', {
    attrs: {
      "name": "tab-fade",
      "mode": "out-in"
    },
    on: {
      "enter": _vm.onEnter,
      "leave": _vm.onLeave
    }
  }, [_c('div', {
    key: _vm.activeIndex,
    staticClass: "flexs absolute",
    class: _vm.activeIndex == 1 ? 'top-bg' : 'bottom-bg'
  }, [_c('img', {
    attrs: {
      "src": _vm.getImagePath(0, _vm.activeIndex)
    }
  })])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };